export function isInPast(receivedTimestamp) {
    const currentTimestamp = Math.floor(Date.now() / 1000);
    return receivedTimestamp < currentTimestamp;
}

// Convert Date to UNIX timestamp (seconds)
export function dateToTimestamp(date) {
    return Math.floor(date.getTime() / 1000);
}

// Convert UNIX timestamp (seconds) to Date
export function timestampToDate(timestamp) {
    return new Date(timestamp * 1000);
}

export function timeConverter(UNIX_timestamp) {
    const date = new Date(UNIX_timestamp * 1000);
  
    // Get the year, month, day, hours, and minutes
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    // Format the date and time in YYYY-MM-DDTHH:mm (ISO 8601 format for datetime-local)
    // without seconds as they are not supported by the input
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function dateConverter(UNIX_timestamp) {
    const date = new Date(UNIX_timestamp * 1000);
  
    // Get the year, month, day, hours, and minutes
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function formatDuration(minutes) {
    if(minutes == 0) return "-";
    // formats by minutes, hours, days
    const remainder = minutes % 60;
    const hours = Math.floor((minutes - remainder) / 60) % 24;
    const days = Math.floor((minutes - remainder) / 60 / 24);

    let strs = [];
    if(days != 0) strs.push(days + " p");
    if(hours != 0) strs.push(hours + " h");
    if(remainder != 0) strs.push(remainder + " min");
    return strs.join(" ");
}